export default "__VITE_ASSET__B0a0Fn7r__"